
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import Sidebar from '/home/circleci/app/packages/layout-sidebar-component/src/entries/Guest';

const element = typeof document !== 'undefined' && document.querySelector('#Sidebar');
if (element) {
    const props = window.initialData['Sidebar'];
    ReactDOM.hydrate(
        <Sidebar {...props}/>,
        element
    );
}
export default Sidebar;
